<template>
  <span class="navbar-icons-wrapper">
    <notification-info-list-nav ref="notificationInfoList" />
    <notification-alarm-list-nav ref="notificationAlarmList" />
    <template v-if="canManageEvents && !touchMode">
      <b-navbar-nav class="event-management-navbar">
        <b-nav-item
          v-tooltip="$t('component.calendar.eventManagement')"
          class="d-flex align-items-center navbar-badge calendar-nav notification-nav mx-2"
          @click="$refs.eventManagementModalWrapper.show()"
        >
          <i
            class="fal fa-calendar-alt"
            aria-hidden="true"
          />
          <b-badge class="vt-nav-badge events">{{ unconfirmedPersonnelEventsCount }}</b-badge>
        </b-nav-item>
      </b-navbar-nav>
      <modal-wrapper ref="eventManagementModalWrapper">
        <event-management-modal
          ref="eventManagementModal"
          @eventManagementUpdated="getUnconfirmedPersonnelEventsSummary"
        />
      </modal-wrapper>
    </template>
  </span>
</template>

<script>
import NotificationInfoListNav from '@/components/NavBar/notifications/NotificationInfoListNav'
import NotificationAlarmListNav from '@/components/NavBar/notifications/NotificationAlarmListNav'
import sessionStore from '@/session/sessionStore'
import toastr from 'toastr'
import EventManagementModal from '@/components/NavBar/notifications/EventManagementModal'
import PersonnelEventsForEventManagersServices
    from '@/api/resources/personnelEvents/personnelEventsForEventManagers/personnelEventsForEventManagersServices'
import { PersonnelOperation } from '@/api/operations/models/personnel-operation'
import { UserType } from '@/api/resources/common/initialization/common-initialization.dto.ts'

export default {
    name: 'NotificationsSection',
    components: {
        NotificationInfoListNav,
        NotificationAlarmListNav,
        EventManagementModal
    },
    props: {
        touchMode: { type: Boolean, default: false }
    },
    data() {
        return {
            notificationSubscription: null,
            notificationsCount: 0,
            limitMessageToasterOpen: false,
            unconfirmedPersonnelEventsCount: 0
        }
    },
    computed: {
        canManageEvents() {
            return this.$store.getters.userInformation.userType !== UserType.PETITIONER &&
                this.hasOperationInCurrentLaboratoryGlobalMixin(PersonnelOperation.EVENT_MANAGE)
        },
        stompClient() {
            return sessionStore.state.stompClient
        },
        laboratoryId() {
            return this.$store.getters.labId
        }
    },
    watch: {
        stompClient() {
            try {
                this.unsubscribeFromNotification()
            } catch (e) {
                console.error(e)
            }
            this.createNotificationSubscriptionIfNotSet()
        }
    },
    async created() {
        this.createNotificationSubscriptionIfNotSet()
        if (this.canManageEvents) {
            await this.getUnconfirmedPersonnelEventsSummary()
        }
    },
    beforeDestroy() {
        this.unsubscribeFromNotification()
    },
    methods: {
        async getUnconfirmedPersonnelEventsSummary() {
            const response =
                await this.$_toCallSecure(
                    PersonnelEventsForEventManagersServices.getLaboratoryUnconfirmedPersonnelEvents(
                        this.laboratoryId))
            if (response) {
                this.unconfirmedPersonnelEventsCount = response
            }
        },
        createNotificationSubscriptionIfNotSet() {
            if (this.stompClient && !this.notificationSubscription) {
                const userId = this.$store.getters.userInformation?.id
                if (userId) {
                    this.notificationSubscription =
                        this.stompClient.subscribe(
                            `/topic/inbox-notification/user/${userId}`,
                            message => this.handleNewNotification(JSON.parse(message.body)))
                }
            }
        },
        handleNewNotification(notification) {
            if (notification.alarm) {
                this.$refs.notificationAlarmList.loadNotifications()
            } else {
                this.$refs.notificationInfoList.loadNotifications()
            }

            if (this.notificationsCount < 5 && !this.limitMessageToasterOpen) {
                this.notificationsCount++
                const toastrOptions = {
                    closeButton: true,
                    positionClass: 'toast-top-right',
                    timeOut: 3000,
                    'onclick': () => {
                        this.$emit('notificationSelected', notification)
                    },
                    'onHidden': () => {
                        this.notificationsCount--
                    }
                }
                if (notification.alarm) {
                    toastr.warning(notification.subject, '', toastrOptions)
                } else {
                    toastr.info(notification.subject, '', toastrOptions)
                }
            } else {
                const toastrOptions = {
                    closeButton: true,
                    positionClass: 'toast-top-right',
                    timeOut: 10000,
                    'onHidden': () => {
                        this.limitMessageToasterOpen = false
                    }
                }
                if (!this.limitMessageToasterOpen) {
                    this.limitMessageToasterOpen = true
                    toastr.info(this.$t('global.notificationLimitMessage'), '', toastrOptions)
                }
            }
        },
        handleReadNotification(notification) {
            if (notification.alarm) {
                this.$refs.notificationAlarmList.loadNotifications()
            } else {
                this.$refs.notificationInfoList.loadNotifications()
            }
        },
        unsubscribeFromNotification() {
            if (this.notificationSubscription) {
                const notificationSubscription = this.notificationSubscription
                this.notificationSubscription = null
                notificationSubscription.unsubscribe()
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .navbar-icons-wrapper {
        display: flex;
    }
    .calendar-nav.notification-nav .nav-link:focus {
        color: #FFF !important;
    }
</style>
